// extracted by mini-css-extract-plugin
module.exports = {"loadingOverlay":"PaymentStripe_loadingOverlay__K1gST"};